import React from 'react'
//import { SvgIcon } from '@material-ui/core'
// import { Button, useRedirect } from 'react-admin'
// import { useTranslation } from 'react-i18next'

//import { ReactComponent as OpenPdfIcon } from 'src/assets/icons/open-pdf.svg'

import CustomBulkActions from 'src/adminPanel/screens/List/BulkActionButtons'

//import { MAX_CONSOLIDATED_ALARMS } from './useAlarmReportProps'

type TListBulkActionsProps = {
  selectedIds?: string[]
}

const BulkActions = CustomBulkActions as unknown as React.ComponentType<
  React.PropsWithChildren<Record<string, unknown>>
>

// j'ai commenté le btn car PO pas d'accord sur le fait de mettre un bouton pour ouvrir le pdf consolidé, on le rajoutera surement en 2027-R1

const ListBulkActions = (props: TListBulkActionsProps): JSX.Element => {
  // const selectedIds = props.selectedIds ?? []
  // const { t } = useTranslation()
  // const redirect = useRedirect()

  // const openConsolidated = (): void => {
  //   redirect(`/pdf/alarms?ids=${selectedIds.join(',')}`)
  // }

  return (
    <BulkActions {...props} />
    // <BulkActions {...props}>
    //   <Button
    //     onClick={openConsolidated}
    //     disabled={
    //       selectedIds.length === 0 ||
    //       selectedIds.length > MAX_CONSOLIDATED_ALARMS
    //     }
    //     label={t('alarm_report.export.bulk.open', {
    //       count: selectedIds.length,
    //     })}
    //   >
    //     <SvgIcon
    //       component={OpenPdfIcon}
    //       viewBox='0 0 30 30'
    //     />
    //   </Button>
    // </BulkActions>
  )
}

export default ListBulkActions
